var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7531 3.21866C14.0719 3.51241 14.0719 3.98741 13.7531 4.25304L5.50313 12.503C5.2375 12.8218 4.7625 12.8218 4.46875 12.503L0.219656 8.25304C-0.0732187 7.98741 -0.0732187 7.51241 0.219656 7.21866C0.5125 6.92804 0.9875 6.92804 1.28031 7.21866L5 10.9405L12.7188 3.21866C13.0125 2.92679 13.4875 2.92679 13.7531 3.21866Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.0b6ebaaa52b6af1e14e2f69e043ceee3.svg";
export { ForwardRef as ReactComponent };